const translations = {
    'founding.title': 'Załóż osadę',
    'founding.alreadySettled': 'Ten region ma już osadę.',
    'founding.notControlled': 'Nie kontrolujesz tego regionu.',
    'founding.inProgress': 'Wyprawa osadnicza już trwa.',
    'founding.noPopulation': 'Brak osady z wystarczającą wolną populacją.',
    'founding.destination': 'Cel',
    'founding.tile': 'Pole: %s',
    'founding.distance': 'Dystans: %d',
    'founding.source': 'Z: %s',
    'founding.population': 'Osadnicy',
    'founding.populationRequired': 'Wymagane: %d',
    'founding.populationFree': 'Wolna populacja: %d',
    'founding.escort': 'Eskorta',
    'founding.escortSelected': 'Milicja: %d/%d',
    'founding.unitPlus': '+1',
    'founding.unitMinus': '-1',
    'founding.food': 'Zaopatrzenie',
    'founding.foodAvailable': 'Dostępne jedzenie: %d',
    'founding.foodSelected': 'Wybrane jedzenie: %d',
    'founding.foodSuggested': 'Sugerowane: %d',
    'founding.foodPlus': '+ jedzenie',
    'founding.foodMinus': '- jedzenie',
    'founding.supplies': 'Ładunek',
    'founding.toolsRequired': 'Wymagane narzędzia: %d',
    'founding.resourceLine': '%s: %d/%d',
    'founding.resourcePlus': '+',
    'founding.resourceMinus': '-',
    'founding.launch': 'Wyprawa',
    'founding.send': 'Wyślij wyprawę',
};

export default translations;
